import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { clearToken } from "../utils/auth";

function Header() {
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setLoggedIn(!!user);
    });
    return () => unsub();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    clearToken();
    setLoggedIn(false);
    try { window.dispatchEvent(new Event('authChanged')); } catch(e){}
    navigate('/login');
  };

  return (
    <header className="bg-blue-700 text-white p-4 shadow">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="AutoIP Logo" className="w-8 h-8 rounded-full bg-white border border-blue-200" />
          <Link to="/" className="text-2xl font-extrabold tracking-wide hover:text-blue-100 transition-colors">
            AutoIP
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <Link 
            to="/history" 
            className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded-lg font-medium transition-colors"
          >
            📜 History
          </Link>
          {loggedIn ? (
            <button onClick={handleLogout} className="bg-white text-blue-700 px-3 py-1 rounded font-medium">Logout</button>
          ) : (
            <Link to="/login" className="bg-white text-blue-700 px-3 py-1 rounded font-medium">Login</Link>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
